module.exports = __webpack_public_path__ + "media/images/ui__arrowRight-76c2b45c763461a795419fb77c9d8491.png";